import React, { useState } from 'react';
import Imagez from '../lib/reusable/Imagez';
import LayersIcon from '@mui/icons-material/Layers';
import DragHandleIcon from '@mui/icons-material/DragHandle';
import EditIcon from '@mui/icons-material/Edit';

import { COLORS } from '../utils/colors';

const RepositionItem = (props) => {
  const { item, position, action } = props;

  const [errorImage, setErrorImage] = useState(false);

  if (!item) return null;

  const hasImage = ((item.has_image && item.image) || item.randomImageFromProducts) && !errorImage;

  const handleNoImage = () => {
    setErrorImage(true);
  };

  const square = '40px';

  const positionCheck = item.position < 0 ? item.position + 1 : item.position - 1;
  const cursor = action ? { cursor: 'pointer' } : {};

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        opacity: item.active ? 1 : 0.3,
        marginLeft: '-4px',
        borderLeft:
          Math.abs(positionCheck) !== position
            ? `2px solid ${COLORS.DANGER}`
            : `2px solid ${COLORS.INFO}`,
        // borderRadius: '4px',
        padding: '8px',
        backgroundColor: `${COLORS.INFO}05`,
        boxShadow: '0px 6px 8px -3px #00000040',
        ...cursor,
      }}
      onClick={action ? action : () => null}
    >
      <div style={{ display: 'flex', alignItems: 'center', fontSize: '0.9rem' }}>
        <div
          style={{
            fontWeight: 'bold',
            letterSpacing: '-0.024em',
            marginRight: '10px',
            fontSize: '0.64rem',
          }}
        >
          {position + 1}
        </div>
        {hasImage ? (
          <div style={{ width: square, borderRadius: '4px' }}>
            <Imagez
              br="4px"
              image={item.has_image ? item.image : item.randomImageFromProducts}
              height={square}
              handleNoImage={handleNoImage}
              style={{ opacity: item.active ? 1 : 0.3 }}
              loaderWidth={30}
            />
          </div>
        ) : (
          <div style={{ width: square, height: square, background: '#ccc', borderRadius: '4px' }} />
        )}
        {item.group && (
          <div style={{ fontWeight: 'bold', letterSpacing: '-0.024em', marginLeft: '10px' }}>
            <LayersIcon className="txt-info s-24-i" />
          </div>
        )}
        <div style={{ fontWeight: 'bold', letterSpacing: '-0.024em', marginLeft: '10px' }}>
          {item.name}
        </div>
      </div>
      <div className="f-c f-aic">
        {action ? (
          <EditIcon className="s-24-i txt-info ml-8" />
        ) : (
          <DragHandleIcon className="s-24-i txt-info ml-16" />
        )}
      </div>
    </div>
  );
};

export default RepositionItem;
